import React from 'react';
import { Button, Container, Typography } from '@mui/material';

function UnAuthorized({ children }) {
  return (
    <React.Fragment>
      {children != null && children}

      {children == null && (
        <Container>
          <Typography>
            You are not authorized to access this resource
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              localStorage.removeItem(`token-${process.env.REACT_APP_APPID}`);
              window.location.href = '/logout?reason=session-expired';
            }}
          >
            Go Back Home
          </Button>
        </Container>
      )}
    </React.Fragment>
  );
}

export default UnAuthorized;
